﻿<template>
    <q-dialog ref="dialogRef" @keydown.enter.stop.prevent="onSave">
        <q-card class="q-dialog-plugin">
            <q-card-section class="row items-center">
                {{ props.title }}
            </q-card-section>

            <q-card-section class="row items-center">
                <q-form class="dialog-form">
                    <q-input
                        v-model="finishTime"
                        dense
                        autofocus
                        mask="fulltime"
                        :roles="['fulltime']"
                        :label="props.label"
                        @focus="$event.target.select()"
                    >
                        <template v-slot:append>
                            <q-icon name="access_time" class="cursor-pointer">
                                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                                    <q-time v-model="finishTime" flat now-btn with-seconds format24h>
                                        <div class="row items-center justify-end">
                                            <q-btn v-close-popup :label="ts('close')" color="primary" flat />
                                        </div>
                                    </q-time>
                                </q-popup-proxy>
                            </q-icon>
                        </template>
                    </q-input>
                </q-form>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat :label="props.save" color="primary" @click="onSave" />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script setup lang="ts">
import { useDialogPluginComponent } from 'quasar'
import { ts } from '@/plugins/i18nFormat'
import { ref } from 'vue'

interface Props {
    title?: string
    label?: string
    value?: string
    save?: string
    color?: string
}

const props = withDefaults(defineProps<Props>(), {
    title: '',
    label: '',
    color: 'primary',
    value: null,
    save: () => ts('ok'),
})

defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogOK } = useDialogPluginComponent()

const finishTime = ref(props.value)

function enterPressed() {
    console.log('enter')
}

function onSave() {
    onDialogOK({
        finishTime: finishTime.value,
    })
}
</script>

<style scoped lang="sass">
.dialog-form
    width: 100%
</style>
